module.exports = __webpack_public_path__ + "img/grapes_grey.9500bc43.svg";